import { useState } from 'react';
import { useLocales } from 'src/locales';
import { Helmet } from 'react-helmet-async';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Iconify from 'src/components/iconify';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import { enqueueSnackbar } from 'notistack';
import Domain from '../domain';
import { useGetCustomDomainsQuery, useBulkCreateCustomDomainsMutation } from 'src/context/api/sso/api';
// ----------------------------------------------------------------------

export default function ListIntegrations() {
  const { t } = useLocales();
  const { data: domains, isLoading: isLoadingCustomDomains, refetch: resyncDomains } = useGetCustomDomainsQuery(null);
  const [bulkCreateDomains,] = useBulkCreateCustomDomainsMutation();

  const handleBulkCreateDomains = () => {
    const bulkCreateRequest = bulkCreateDomains(domains?.map((domain) => ({
      name: domain.name,
      domains: domain.aliases,
      identifier: domain.identifier,
    })) ?? []).unwrap();

    bulkCreateRequest.then((res) => {
      if (res.insert > 0) {
        enqueueSnackbar(t('dashboard.admin.sso.domain_created'), { variant: 'success' });
        resyncDomains();
      }
      else {
        enqueueSnackbar(t('dashboard.admin.sso.nothing_to_create'), { variant: 'warning' });
      }
    }).catch((err) => {
      enqueueSnackbar(t('dashboard.admin.sso.domain_creation_failed'), { variant: 'error' });
    });
  }

  return (
    <Box px={"24px"}>

      <Card>
        <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"} p={3}>
          <Box>
            <Typography>{t('dashboard.admin.sso.description')}</Typography>
            <Typography variant="h6">{t('dashboard.admin.sso.header')}</Typography>
          </Box>
          <Stack direction="row" spacing={2}>
            <Button size='small' variant="contained" startIcon={<Iconify icon="mingcute:external-link-line" />} target="_blank" color="primary" href={"https://manage.auth0.com/dashboard/us/" + process.env.REACT_APP_AUTH0_TENANT + "/connections/enterprise"}>
              {t("dashboard.admin.sso.configure_auth0")}
            </Button>
            <Button
              size='small'
              variant="contained"
              startIcon={<Iconify icon="mingcute:add-line" />}
              onClick={handleBulkCreateDomains}
            >
              {t('dashboard.admin.sso.sync_domains')}
            </Button>
          </Stack>
        </Box>
        <CardContent>
          {
            isLoadingCustomDomains ? (
              <Box sx={{ textAlign: 'center', py: 5 }}>
                <CircularProgress />
              </Box>
            ) : domains?.length === 0 ? (
              <Box sx={{ textAlign: 'center', py: 5 }}>
                <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                  No SSO integrations found
                </Typography>
              </Box>
            ) : (
              <Box>
                {domains?.map((domain, idx) => (
                  <>
                    {idx !== 0 && <Divider sx={{ my: 2 }} />}
                    <Domain domain={domain} domains={domains} resyncDomains={resyncDomains} />
                  </>
                ))}
              </Box>
            )}
        </CardContent>
      </Card>
    </Box>
  );
}

